import React from 'react'
import PropTypes from 'prop-types'
import ViewYourPlan from './ViewYourPlan/ViewYourPlan'
import styles from './GoalsAndInvestmentStrategyBase.module.scss'
import GoalsAndInvestmentStrategyBlurb from './GoalsAndInvestmentStrategyBlurb/GoalsAndInvestmentStrategyBlurb'
import YourGoals from './YourGoals/YourGoals'
import { BaseComponent } from 'belle-js'
import { trackAnalyticsEvent } from 'analytics'

class GoalsAndInvestmentStrategyBase extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {
      bgImageUrl: '/images/goals_and_investment_strategy_mobile.png'
    }

    this.bind('handleViewYourPlan')
  }

  handleViewYourPlan () {
    trackAnalyticsEvent('View My Plan Clicked')
  }

  render () {
    const { currentInvestmentPlan } = this.props

    return (
      <section className={styles.container}>
        <div className={styles.centerContent}>
          <div className={styles.investmentColumn} data-test-id="investmentColumn">
            <GoalsAndInvestmentStrategyBlurb
              title="Your Goals & Investment Strategy"
              description={currentInvestmentPlan.strategy} />
            <ViewYourPlan onClick={this.handleViewYourPlan} />
          </div>
          <div className={styles.goalsColumn} data-test-id="goalsColumn">
            <YourGoals goalsList={currentInvestmentPlan.goals} />
          </div>
          <img alt="bgImage" data-test-id="bgImage" className={styles.bgImage} src={this.state.bgImageUrl} />
        </div>
      </section>
    )
  }

}

GoalsAndInvestmentStrategyBase.propTypes = {
  currentInvestmentPlan: PropTypes.object.isRequired,
}

export default GoalsAndInvestmentStrategyBase



// WEBPACK FOOTER //
// ./src/components/Client/GoalsAndInvestmentStrategy/GoalsAndInvestmentStrategyBase.jsx